var exports = {
  "kL": "x112a1f60--8e2a36--container",
  "vu": "x112a1f60--8e2a36--active",
  "DD": "x112a1f60--8e2a36--title",
  "WD": "x112a1f60--8e2a36--labels",
};

module.exports = exports;
